<template>
  <div class="customerList">
    <ul>
      <li v-for="(item, index) in list" :key="index" @click="handleClick(item)">
        <div class="row r1">
          {{item.CustomerName}}
          <van-button plain v-if="item.IsInsideText=='是'" type="primary" color="#4FAE54" size="mini">{{item.IsInsideText=='是'?'内部客户':''}}</van-button>
        </div>
        <div class="row r2">
          <span class="col1">地址联系人:{{item.Contacts}}</span>
          <span class="col2">联系电话:{{item.AddressMobile}}</span>
        </div>
        <div class="row r3">详细地址:{{item.Address}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import basedata from "../utils/basedata";
import BuyCarStore from "../store/buycar";
import GroupByList from "../store/Base/GroupByList";
export default {
  name: "customer-list",
  props: {
    list: Array
  },
  data() {
    return {
      buyCarState: BuyCarStore.state,
    };
  },
  created(){
  },
  methods: {
    handleClick(data){
      localStorage.setItem("CustomerID", data.CustomerId);
      sessionStorage.setItem("CustomerName", data.CustomerName);
      sessionStorage.setItem("EmployeeName", data.EmployeeName||'');
      localStorage.setItem("EmployeeMobile", data.EmployeeMobile||'');
      this.$router.push({
        path: "/"
      });
    }
    
  },
};
</script>

<style lang="scss" scoped>
.customerList{
  margin-top:0.3rem;
  li{
    background: #fff;
    -webkit-box-shadow: 0px 3px 11px 5px #ececec78;
    box-shadow: 0px 3px 11px 5px #ececec78;
    padding:10px 12px;
    border-radius: 5px;
    margin:0 0.3rem 0.4rem 0.3rem;
    .row{
      margin:5px 0;
    }
    .r1{
      font-size: 0.28rem;
      font-weight: bold;
      background: url(../assets/icon/username.png) no-repeat 0 center;
      background-size:auto 0.32rem;
      padding-left:25px; 
      color: #333;
      span{
        font-weight: normal;
      }
    }
    .r2{
      display: flex;
      justify-content: space-between;
      color: #666;
      .col1{
        background: url(../assets/icon/user@2x.png) no-repeat 0 top;
        background-size:auto 0.32rem;
        padding-left:18px; 
      }
      .col2{
        background: url(../assets/icon/dh@2x.png) no-repeat 0 top;
        background-size:auto 0.32rem;
        padding-left:18px; 
      }
    }
    .r3{
      background: url(../assets/icon/adress@2x.png) no-repeat 0 top;
      background-size:auto 0.32rem;
      padding-left:18px; 
      color: #666;
    }
  }
}
</style>
